import ProgressBar from '@uikit/components/ProgressBar/ProgressBar';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import styles from './MagazineArticleHeaderProgressBar.module.scss';
import { MagazineArticleHeaderProgressBarProps } from './types';

const MagazineArticleHeaderProgressBar = ({
  isHidden,
}: MagazineArticleHeaderProgressBarProps) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const updateScrollState = () => {
        setScrollProgress(
          ((window.scrollY + window.innerHeight) * 100) /
            document.body.clientHeight
        );
      };
      window.addEventListener('scroll', updateScrollState, { passive: true });
      updateScrollState();
      return () => {
        window.removeEventListener('scroll', updateScrollState);
      };
    }
  }, []);

  return (
    <div className={styles.container}>
      <ProgressBar
        className={clsx(styles.base, { [styles.isHidden]: isHidden })}
        progress={scrollProgress}
        visible
      />
    </div>
  );
};

export default MagazineArticleHeaderProgressBar;
